import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MailCheck, RefreshCw } from "lucide-react";
import aapi, { fmtDate } from "./aapi";
import { PageHeader, EmptyState } from "@/panel/components";
import { EASE } from "@/components/Motion";

export default function AdminMailLog() {
  const [logs, setLogs] = useState(null);

  const load = () => aapi.get("/mail-log").then(({ data }) => setLogs(data)).catch(() => setLogs([]));
  useEffect(() => {
    load();
  }, []);

  return (
    <div data-testid="admin-mail-log-page">
      <PageHeader title="Mail History" sub="Har bheji gayi mail ka record — kab, kis subject se, kitne recipients ko, kitni deliver hui." />

      <div className="mb-5 flex justify-end">
        <button onClick={load} data-testid="mail-log-refresh"
          className="flex items-center gap-2 rounded-xl border border-gold/40 px-4 py-2 text-[11px] font-bold text-goldlight transition-colors hover:bg-gold/10">
          <RefreshCw size={13} /> REFRESH
        </button>
      </div>

      {logs === null ? (
        <div className="flex justify-center py-24">
          <div className="h-10 w-10 animate-spin rounded-full border-2 border-gold/20 border-t-gold" />
        </div>
      ) : logs.length === 0 ? (
        <EmptyState icon={MailCheck} title="No mails yet" sub="Send Mail page se bheji gayi mails yahan dikhengi." testid="mail-log-empty" />
      ) : (
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }}
          className="overflow-x-auto rounded-2xl border border-white/10" data-testid="mail-log-table">
          <div className="min-w-[860px]">
            <div className="grid grid-cols-12 gap-3 border-b border-white/10 bg-white/[0.02] px-5 py-3 font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-500">
              <span className="col-span-2">Date</span>
              <span className="col-span-4">Subject</span>
              <span className="col-span-2">Recipients</span>
              <span className="col-span-1">Sent</span>
              <span className="col-span-2">Failed</span>
              <span className="col-span-1 text-right">By</span>
            </div>
            {logs.map((m) => (
              <div key={m.id} data-testid={`mail-log-row-${m.id}`}
                className="grid grid-cols-12 items-center gap-3 border-b border-white/5 bg-panel/80 px-5 py-3.5 last:border-0">
                <span className="col-span-2 font-mono text-[10px] text-neutral-500">{fmtDate(m.created_at)}</span>
                <span className="col-span-4 truncate text-xs text-neutral-200" title={m.subject}>{m.subject}</span>
                <span className="col-span-2 truncate text-[11px] text-neutral-400" title={m.to || ""}>
                  {m.to || `${m.total} recipient(s)`}
                </span>
                <span className="col-span-1">
                  <span className="rounded-full bg-emerald-400/15 px-2 py-0.5 font-mono text-[10px] text-emerald-300" data-testid={`mail-sent-${m.id}`}>
                    {m.sent}
                  </span>
                </span>
                <span className="col-span-2">
                  {m.failed > 0 ? (
                    <span className="rounded-full bg-amber-400/15 px-2 py-0.5 font-mono text-[10px] text-amber-300"
                      title={(m.failed_list || []).join(", ")} data-testid={`mail-failed-${m.id}`}>
                      {m.failed} failed
                    </span>
                  ) : (
                    <span className="font-mono text-[10px] text-neutral-600">0</span>
                  )}
                </span>
                <span className="col-span-1 truncate text-right font-mono text-[9px] text-neutral-600" title={m.admin}>
                  {(m.admin || "").split("@")[0]}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
}
